module.exports = __webpack_public_path__ + "img/document-upload.3906fda6.svg";